import { render, staticRenderFns } from "./FormDesign.vue?vue&type=template&id=696a859a&"
import script from "./FormDesign.vue?vue&type=script&lang=js&"
export * from "./FormDesign.vue?vue&type=script&lang=js&"
import style0 from "./FormDesign.vue?vue&type=style&index=0&id=696a859a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports